import { render, staticRenderFns } from "./pwa_location_image.vue?vue&type=template&id=7478dd04&scoped=true&"
import script from "./pwa_location_image.vue?vue&type=script&lang=js&"
export * from "./pwa_location_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7478dd04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7478dd04')) {
      api.createRecord('7478dd04', component.options)
    } else {
      api.reload('7478dd04', component.options)
    }
    module.hot.accept("./pwa_location_image.vue?vue&type=template&id=7478dd04&scoped=true&", function () {
      api.rerender('7478dd04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/location/tabs/pwa_location_image.vue"
export default component.exports